import React, { FC } from "react"

export const OneIcon: FC = () => (
  <svg
    width="14"
    height="21"
    viewBox="0 0 14 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.48 18.6H6.21V3.18L0.48 6.87V4.2L7.02 -1.43051e-06H8.97V18.6H13.02V21H0.48V18.6Z"
      fill="white"
    />
  </svg>
)
